module.exports = __webpack_public_path__ + "static/media/Trein.fadeeebc.mp3";